import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import { LicenseManager } from "ag-grid-enterprise";
import { AgGridReact } from "ag-grid-react";
import React from "react";

import config from "@web-app/config";

LicenseManager.setLicenseKey(config.AG_GRID_LICENSE_KEY);

const Table = React.forwardRef<
  AgGridReact,
  React.ComponentProps<typeof AgGridReact>
>((props, ref) => {
  return <AgGridReact {...props} ref={ref} />;
});

export default Table;
